export default {
  link: {
    info_card: {
      title: 'Earn 20% lifetime recurring commission for every monthly subscription paid by your referred users! No limit!',
      description: '<p>Share your referral link with your friends and community, and earn 20% commission for every subscription plan paid by the users you bring to MAXCOM STORE.</br>' + 'When your referred users subscribe to a paid plan, you will earn 20% commission for every month they stay subscribed. Even if they start with the free plan, you will still get the 20% commission when they upgrade to a paid plan.</br>' + 'Start now and watch your commissions grow month after month.</p>',
      copy_link_text: 'Copy your Referral link:',
      tracking_code_text: 'You can also add your tracking codes like so:',
      tracking_info_alert: '<span>{referral_link}<span>?fbp=<span style="color: black">MyFacebookPixelHere</span>&tkp=<span style="color: black">MyTiktokPixelHere</span></span></span>'
    },
    filter: {
      search: {
        placeholder: 'Filter affiliates ...'
      },
      status: {
        placeholder: 'All statuses'
      },
      role: {
        placeholder: 'All roles'
      },
      country: {
        placeholder: 'All countries'
      },
      referrer: {
        placeholder: 'All referrers'
      },
      sort: {
        new_to_old: 'New to old',
        old_to_new: 'Old to new'
      }
    },
    table_card: {
      table: {
        sign_up_date: 'Signup date',
        referrer: 'Referrer',
        role: 'Role',
        user_name: 'Username',
        full_name: 'Full name',
        contact_details: 'Contact details',
        country: 'Country',
        subscription_plan: 'Subscription Plan',
        assigned_manager: 'Assigned manager',
        commission: 'Commission'
      }
    }
  },
  invoices: {
    info_card: {
      title: 'Referral Invoices',
      description: 'When your referred users subscribes to paid plan, we will show you here their invoices and the commission you earned from their subscribed plan (20% from every paid invoice) .</br>' + 'To generate a referral invoice and request a payment you should have accumulated a total of $50 commissions or more from your referrals commissions.</br>' + 'Every Monday we will process payments for your generated invoices.'
    },
    filter: {
      referrer: {
        title: 'All Referrers'
      },
      generated_for: {
        title: 'All generated got users'
      }
    },
    table_card: {
      description: 'Here you will see a list of your earned commissions from your referred users </br>' + '(We will show here only the list of invoices filtered by the user who referred, and by the status of invoice “paid”)',
      total_commission: 'Total selected commission: $ {total}',
      buttons: {
        generate_payout: 'Generate Payout'
      },
      table: {
        invoice_id: 'Invoice Id',
        created_at: 'Created At',
        referrer: 'Referrer',
        generated_for: 'Generated For',
        subscription_amount: 'Subscription Amount',
        referral_commission: 'Referral Commission'
      }
    }
  },
  payouts: {
    filter: {
      generated_for: {
        title: 'All Generated For Users'
      },
      payment_status: {
        title: 'All Status'
      }
    },
    payment_info: {
      title: 'Payment Information'
    },
    stats: {
      title: 'Total Paid Earnings',
      dates: {
        this_month: 'This Month',
        last_month: 'Last Month',
        this_year: 'This Year',
        last_year: 'Last Year'
      }
    },
    dialogs: {
      delete_confirmation: {
        title: 'Delete Invoice',
        content: 'Are you sure you want to delete this invoice ?'
      }
    },
    info_card: {
      title: 'Referral Payouts',
      description: 'Here you will see all your payouts request for you generated referrals commissions.</br>' + 'To get paid you should have added your preferred payment method, and you should have accumulated a total of $50 commissions or more from your referrals commissions.</br>' + 'Every Monday we will process payments for your generated invoices.'
    },
    table_card: {
      buttons: {
        pay_invoices: {
          pre_text: 'Mark {count} invoice(s) as paid',
          text: 'Pay Invoices'
        }
      },
      table: {
        invoice_id: 'Invoice Id',
        generated_by: 'Generated By',
        created_at: 'Date',
        generated_for: 'Generated For',
        total_commission: 'Total Commission',
        payment_method: {
          title: 'Payment Method',
          placeholder: 'Choose a payment method',
          pending: 'pending...'
        },
        invoice_type: 'Invoice Type',
        status: 'Status',
        payment_id: 'Payment Id',
        actions: 'Actions'
      }
    }
  }
};